import { WrenchTheme } from '@wds/styles';
export { ElevateTheme, WrenchTheme } from '@wds/styles';
import React from 'react';
import { createUseStyles, useTheme, createGenerateId, JssProvider } from 'react-jss';
/* eslint-disable @typescript-eslint/naming-convention */

/** @deprecated - use either `WrenchTheme` or `ElevateTheme` */

const Theme = WrenchTheme;
const prefix = 'smq-';
const selectors = [`[class*='${prefix}']`, `[class*='${prefix}']::before`, `[class*='${prefix}']::after`];
const useStyles = createUseStyles(theme => {
  const {
    fontFamily
  } = theme.type;
  const resetStyles = {
    '-webkit-font-smoothing': 'antialiased',
    boxSizing: 'border-box',
    fontFamily: fontFamily.base,
    listStyle: 'none',
    margin: 0,
    padding: 0
  };
  return {
    '@global': {
      [selectors.join(',')]: resetStyles
    }
  };
}, {
  // Ensure this gets added to as the first stylesheet
  // ref: https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/utils/getSheetIndex.js#L3-L16
  index: (Number.MIN_SAFE_INTEGER || -1e9) - 1,
  name: 'smquestions-global-styles'
});
/* Must by rendered inside StylesProvider and a ThemeProvider with the Wrench/SMQuestions Theme  */

function GlobalStyles() {
  const theme = useTheme();
  useStyles({
    theme
  });
  return null;
}
/*
 * Preserve existing 'wrench*' or 'wds*' format for Wrench components,
 * for targeting within internal selectors, ex. `class^="wdsIcons"`
 * Apply prefix to all other rules for SMQuestions components
 */


const wrenchPrefixOld = 'wds';
const wrenchPrefix = 'wrench';
/* Wraps all components and ThemeProvider of SMQuestions app experience */

function StylesProvider({
  children,
  ...props
}) {
  // https://cssinjs.org/jss-api?v=v10.4.0#generate-your-class-names
  const generateJssId = React.useMemo(() => createGenerateId(), []);

  const generateId = (rule, srcSheet) => {
    const sheet = srcSheet;

    if (sheet && !rule.key.startsWith(wrenchPrefix) && !rule.key.startsWith(wrenchPrefixOld)) {
      sheet.options.classNamePrefix = prefix;
    }

    return generateJssId(rule, sheet);
  };

  return React.createElement(JssProvider, { ...props,
    generateId: generateId
  }, children);
}

export { GlobalStyles, StylesProvider, Theme };